module.exports = __webpack_public_path__ + "media/bootstrap-icons/sun-fill-14a1c287.svg";